var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$vuetify.breakpoint.width < 750)?_c('MobileMainEvents',{attrs:{"mainEvents":_vm.mainEvents}}):_c('DesktopMainEvents',{attrs:{"mainEvents":_vm.mainEvents}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }